<div class="banner" *ngIf="isVisible">
    <div class="row">
        <img src="./images/delivery-wallet/money-icon.svg" loading="lazy" alt="icon">
        <div class="col">
            <h2>Your balance is below a delivery charge</h2>
            <p>
                Please top-up your balance to be able to deliver from your store again
            </p>
            <!-- <h2><?php echo languageDetector('رصيدك أقل من رسوم التوصيل', 'Your balance is below a delivery charge'); ?></h2> -->
            <!-- <p><?php echo languageDetector('يرجى شحن رصيدك لتتمكن من التوصيل من متجرك مرة أخرى', 'Please top-up your balance to be able to deliver from your store again'); ?></p> -->
        </div>
    </div>
    <div class="row">
        <button class="btn sm" id="topUp" (click)="openTopUpModal()">
            Top-up now
            <!-- <?php echo languageDetector('قم بالتعبئة الآن', 'Top-up now'); ?> -->
        </button>
        <button class="btn close" (click)="closeBanner()"><img src="./images/delivery-wallet/x-close.svg" loading="lazy" alt="close"></button>
    </div>
</div>